import { Box, Button, Container, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import Cookies from 'universal-cookie';
import navLogo from '../../assets/images/logo.png';
import { useGetWebhooks, useReturnToMonday } from '../../hooks/useWebhooks';
import WebhookForm from './components/WebhookForm';
import WebhookList from './components/WebhookList';

const WebhooksPage: React.FC = () => {
  const cookies = new Cookies();
  const [addModal, setAddModal] = useState(false);

  const { webhooks, isLoading } = useGetWebhooks();
  const { mutate: returnToMonday } = useReturnToMonday();

  const handleAddWebhook = () => setAddModal(true);
  const handleCloseWebhook = () => setAddModal(false);

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Box>
      <Container maxWidth="lg">
        <Typography variant="h4" component="h1" gutterBottom fontWeight={600} mb={3}>
          Welcome to Luxie Tech&apos;s monday.com/Clockify Integration
        </Typography>

        <Typography variant="body1" paragraph>
          To create a new Clockify Webhook, please visit webhooks in your Clockify Profile settings
          (beneath the API key)
        </Typography>

        <Stack component="ul" sx={{ mb: 4 }} gap={1}>
          <Typography component="li">Create a new webhook</Typography>
          <Typography component="li">
            Set https://clockify.mapps.luxie.tech/clockify/webhook as the Endpoint URL
          </Typography>
          <Typography component="li">
            Select any of the following events:
            <Box component="ul" sx={{ pl: 2, mt: 1 }}>
              <Typography component="li">Time entry deleted</Typography>
              <Typography component="li">Timer started</Typography>
              <Typography component="li">Timer stopped</Typography>
              <Typography component="li">Time entry updated</Typography>
              <Typography component="li">Time entry created manually</Typography>
            </Box>
          </Typography>
          <Typography component="li">Click on Create</Typography>
          <Typography component="li">
            Enter the Webhook Name and Clockify Signing secret after clicking on &quot;Add new
            webhook&quot; below
          </Typography>
        </Stack>

        <Box sx={{ mb: 4 }}>
          <WebhookList webhooks={webhooks} />
        </Box>

        {/* Action Buttons */}
        <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
          <Button size="large" variant="contained" color="primary" onClick={handleAddWebhook}>
            Add new webhook
          </Button>
          <Button size="large" variant="contained" color="primary" onClick={() => returnToMonday()}>
            Return to monday.com
          </Button>
        </Box>

        {/* Modals */}
        <WebhookForm open={addModal} onClose={handleCloseWebhook} />
      </Container>
    </Box>
  );
};

export default WebhooksPage;
